export const quickSearchResultsStyles = {
	listGroup: {
		display: 'flex',
		flexDirection: 'column',
		padding: 0,
		paddingTop: 1,
		listStyleType: 'none'
	},
	listOption: {
		px: 1,
		'&.Mui-focused': {
			backgroundColor: 'primary.hover'
		}
	}
};
